import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { rootReducer } from './rootReducer';
import { listenerMiddleware, wsMiddleware } from './middleware';
import { api } from '@/lib/api';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Actions de WS podem carregar payloads heterogêneos (ex: ArrayBuffer);
        // ignoramos a checagem em prefixos específicos pra não barrar legitimamente.
        ignoredActionPaths: ['payload.error', 'meta.arg'],
      },
    })
      .prepend(listenerMiddleware.middleware)
      .concat(api.middleware, wsMiddleware),
  devTools: import.meta.env.DEV,
});

// Habilita refetchOnFocus/refetchOnReconnect dos endpoints RTK Query.
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
